import { render, staticRenderFns } from "./law_store.vue?vue&type=template&id=4eea1a18"
import script from "./law_store.vue?vue&type=script&lang=js"
export * from "./law_store.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports